import invoiceConstants from "../constants/invoiceConstants";

export const createInvoice = (payload: any) => ({
  type: invoiceConstants.CREATE_INVOICE_REQUEST,
  payload,
});

export const retrieveInvoices = (payload: any) => ({
  type: invoiceConstants.GET_INVOICES_REQUEST,
  payload,
});

export const retrieveInvoiceDetails = (payload: any) => ({
  type: invoiceConstants.GET_INVOICE_DETAILS_REQUEST,
  payload,
});

export const sendInvoice = (payload: any) => ({
  type: invoiceConstants.SEND_INVOICE_REQUEST,
  payload,
});

export const updateInvoice = (payload: any) => ({
  type: invoiceConstants.UPDATE_INVOICE_REQUEST,
  payload,
});

export const resetInvoices = () => ({
  type: invoiceConstants.RESET_INVOICES,
});

export const resetInvoiceSent = () => ({
  type: invoiceConstants.RESET_INVOICE_SENT,
});
